import React, { useState } from 'react';
import { Typography, Box, Card, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
// import Link from '@mui/material/Link';
import { Link } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';
import ItemTable from '../../components/Datatable/ItemTable';
import ListIcon from '@mui/icons-material/List';
import AddIcon from '@mui/icons-material/Add';

function handleClick(event) {
  const value = event.target.value;
  console.log(value);
}

const Items = () => {
  const [activeTab, setActiveTab] = useState('list'); // State to track active tab
  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));

  const breadcrumbs = [
    <Link underline="hover" key="1" style={{ textDecoration: 'none' ,color:'#3c7f06'}} to={'/dashboard'} onClick={handleClick}>
      Dashboard
    </Link>,
    <Typography key="3" sx={{ color: '#99abb4' }}>
      Items
    </Typography>,
  ];

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <Box className="Brands-con-cls">
      <DrawerHeader />
      <Card
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1,
          p: { xs: '20px', sm: '20px 40px' },
          boxShadow: '1px 0 5px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Typography variant="body1" sx={{ mb: 0, color: '#000', fontWeight: 600, fontSize: '22px' }}>
          Items
        </Typography>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          {breadcrumbs}
        </Breadcrumbs>
      </Card>

      {/*  */}
      <Box sx={{ p: 3 }}>
        <Card sx={{ mt: '20px', p: '0', boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.05)' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'end',
              bgcolor: 'rgba(0,0,0,.03)',
              p: '10px 20px 0',
              borderBottom: '1px solid rgba(0,0,0,.125)',
              gap: { xs: '10px', md: 0 }, // Apply gap on small screens
    flexWrap: { xs: 'wrap', md: 'nowrap' }
            }}
          >
            <Button
              variant="text"
              className="category-btn-cls"
              onClick={() => handleTabChange('list')}
              sx={{
                bgcolor: activeTab === 'list' ? '#3c7f06' : 'transparent',
                color: activeTab === 'list' ? '#f1f1f1' : '#000',
                display: 'flex',
                alignItems: 'center',
                fontWeight: activeTab === 'list' ? 600 : 400,
              }}
            >
              <ListIcon />
              Items List
            </Button>
            {/* <Button
              variant="text"
              className="category-btn-cls"
              onClick={() => handleTabChange('create')}
              sx={{
                bgcolor: activeTab === 'create' ? '#3c7f06' : 'transparent',
                color: activeTab === 'create' ? '#f1f1f1' : '#000',
                display: 'flex',
                alignItems: 'center',
                fontWeight: activeTab === 'create' ? 600 : 400,
              }}
            > */}
              
            {/* </Button> */}
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{ bgcolor: 'transparent', color: '#000', boxShadow: 'unset' }}
            >
            <Link to='/items/create' style={{ textDecoration: 'none', color: '#000' }}>
            Create item
            </Link>
            </Button>
          </Box>
          <Box sx={{ p: 2 }}>
            {/* Show the ItemTable when the 'list' tab is active */}
            {activeTab === 'list' && <ItemTable />}
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default Items;
